import {get, put} from "../util/http.service";

export const getContext = params => get("/app/context", params);

export const getI18n = locale => get("/app/i18n/" + locale);

export const completeAssistant = () => put("/app/assistant");
